var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              ref: _vm.ieVerifyGrid,
              attrs: {
                "config-module": "2102",
                "is-collapse-list": true,
                "grid-options": _vm.gridOptions,
                "is-append-query": true,
                reset: true,
                lob: "IE",
                "custom-search-items": _vm.customSearchItems,
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.QuickSearchBusinessNo"
                ),
                "record-expand-status": true,
                "input-enter-query": true,
                "grid-config-module": "170004"
              },
              on: {
                "click-more": function(value) {
                  _vm.isAdvancedQuery = value
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery,
                defaultSearchItemsChange: function(value) {
                  _vm.defaultSearchItems = value
                },
                perConfigChange: function(value) {
                  _vm.perConfigName = value
                },
                refreshGrid: function() {
                  _vm.gridRefreshId += 1
                }
              }
            },
            [
              _c(
                "template",
                { slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled:
                          !_vm.selectedRow ||
                          _vm.hqDisabledViewDetail ||
                          (!_vm.isHQ && !_vm.validSingleSelect) ||
                          _vm.hierarchyDisabledViewDetail,
                        no: "look",
                        type: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toLook()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled:
                          _vm.JobUtils.isBlockJob(_vm.currentRow) ||
                          !_vm.validSingleSelect ||
                          !_vm.hierarchyValidSingleSelect,
                        no: "edit",
                        type: "success"
                      },
                      on: { click: _vm.toEdit }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: [_vm.addButtonPermission],
                          expression: "[addButtonPermission]"
                        }
                      ],
                      attrs: {
                        no: "new",
                        disabled: _vm.hqDisabledOperate,
                        type: "primary"
                      },
                      on: { click: _vm.toAdd }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: [_vm.addButtonPermission],
                          expression: "[addButtonPermission]"
                        }
                      ],
                      attrs: {
                        no: "Clone",
                        disabled:
                          !_vm.selectedRow ||
                          !_vm.validSingleSelect ||
                          !_vm.hierarchyValidSingleSelect,
                        type: "primary"
                      },
                      on: { click: _vm.toCopy }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.role.acceptRole,
                          expression: "role.acceptRole"
                        }
                      ],
                      attrs: { no: "PassAudit", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.acceptHandler(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.PassAudit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.role.rejectRole,
                          expression: "role.rejectRole"
                        }
                      ],
                      attrs: { no: "Refuse", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.rejectHandler(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.role.reviewThroughRole &&
                            _vm.pretrialReviewConfig,
                          expression:
                            "role.reviewThroughRole && pretrialReviewConfig"
                        }
                      ],
                      attrs: { no: "ReviewThrough", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.btVerifyReviewThroughHandler(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.VerifyReviewThrough")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.role.reviewRefusalRole &&
                            _vm.pretrialReviewConfig,
                          expression:
                            "role.reviewRefusalRole && pretrialReviewConfig"
                        }
                      ],
                      attrs: {
                        no: "ReviewRefusal",
                        disabled: _vm.reviewRefusalBtn,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.btVerifyReviewRefusalHandler(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.VerifyReviewRefusal")))]
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { "min-height": "350px" }
            },
            [
              _c("cargo-ag-grid-wrapper", {
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "170004",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.finalColumnDefs,
                  "row-data": _vm.rowData,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "show-selected-color": false,
                  "wrap-text": true,
                  "show-row-groups": _vm.dataListDragGroup,
                  "pre-column-state-callback": function(p) {
                    return _vm.preColumnStateCallback(p)
                  },
                  "per-config-name": _vm.perConfigName,
                  "refresh-id": _vm.gridRefreshId
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  },
                  columnRowGroupChanged: function() {
                    this$1.$refs[_vm.ieVerifyGrid].clickCollapseList()
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.appendQuery,
                    expression: "!appendQuery"
                  }
                ],
                attrs: {
                  "config-module": "170004",
                  total: _vm.total,
                  "page-count": _vm.pageCount,
                  page: _vm.pageNum,
                  limit: _vm.pageSize
                },
                on: {
                  "update:page": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:limit": function($event) {
                    _vm.pageSize = $event
                  },
                  pagination: function($event) {
                    return _vm.toQuery()
                  }
                }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.appendQuery,
                      expression: "appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: { total: _vm.total, layout: "total" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.acceptDialog.visible
        ? _c("accept-dialog", {
            attrs: {
              visible: _vm.acceptDialog.visible,
              "job-model": _vm.acceptDialog.job || {},
              "submit-call-back": _vm.acceptDialog.submitCallBack,
              "job-list": _vm.acceptDialog.jobs
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.acceptDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.rejectWindow.visible
        ? _c("reject-dialog", {
            attrs: {
              visible: _vm.rejectWindow.visible,
              "job-no": _vm.rejectWindow.jobNo,
              "job-list": _vm.rejectWindow.jobList,
              "reject-call-back": _vm.rejectWindow.rejectCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.rejectWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            ref: "batchCheckingWindow",
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              "allow-partial-check-pass":
                _vm.batchCheckingWindow.allowPartialCheckPass,
              lob: "IE",
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.confirmDialogWindow.visible
        ? _c("confirm-dialog-window", {
            attrs: {
              visible: _vm.confirmDialogWindow.visible,
              "message-title": _vm.confirmDialogWindow.messageTitle,
              content: _vm.confirmDialogWindow.content,
              "show-confirm-btn": _vm.confirmDialogWindow.showConfirmBtn,
              "confirm-call-back": _vm.confirmDialogWindow.confirmCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.confirmDialogWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.cooperationVerifyDialog.visible
        ? _c("cooperation-verify-dialog", {
            attrs: {
              visible: _vm.cooperationVerifyDialog.visible,
              "job-uuid": _vm.cooperationVerifyDialog.jobUuid,
              cooperate: _vm.cooperationVerifyDialog.cooperate,
              "submit-call-back": _vm.cooperationVerifyDialog.submitCallBack,
              editable: _vm.cooperationVerifyDialog.editable
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cooperationVerifyDialog, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }